var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1.Bace\u57FA\u7840/3.Icon\u56FE\u6807/\u5176\u4ED6/layers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.Bace\\u57FA\\u7840/3.Icon\\u56FE\\u6807/\\u5176\\u4ED6/layers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L16,0 L16,16 L0,16 L0,0 Z",
    id: "layers-(Background)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99975586,7.5084095 L1.92640564,4.97791052 C1.5159767,4.80690241 1.51597583,4.20040798 1.92640558,4.02939963 L7.99975586,1.49890137 L14.0731058,4.02939963 C14.4835348,4.20040751 14.4835358,4.80690193 14.0731068,4.97791028 L7.99975586,7.5084095 Z M7.99975586,2.59850323 L12.572237,4.50365543 L7.99975538,6.40880775 L3.42727458,4.50365567 L7.99975586,2.59850323 Z M1.49902344,8.25379086 L8.00001335,11.1119394 L14.4990234,8.25466061 L14.4990234,7.02751637 L8.00001335,9.88479519 L1.49902344,7.02664614 L1.49902344,8.25379086 Z M1.49902344,11.6465769 L8.00010777,14.5047674 L14.4990234,11.6475306 L14.4990234,10.4203844 L8.00010777,13.2776222 L1.49902344,10.4194317 L1.49902344,11.6465769 Z",
    id: "layers",
    fillOpacity: 0.899999976,
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.ac69ea70bc5d978992551b0e953893ee.svg";
export { ForwardRef as ReactComponent };